import React from 'react';
import {useNavigate} from 'react-router-dom';
import {AurDropdownButton} from '../common/aur-button/AurDropdownButton';
import {ReactComponent as PlusIcon} from '../../../src/assests/svg/plus-icon.svg';

import {t} from 'i18next';

const BulkUserLandingPage: React.FC = () => {
  const navigate = useNavigate();

  // Handle navigation
  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <>
      {/* code for addUser button on manageUser screen,  this will be removed once manageUser page is created */}
      <AurDropdownButton
        buttonText={t('buttons.addTeamMember')}
        type="not"
        startIcon={<PlusIcon aria-hidden="true" />} //optional Icon
        iconType="Other"
        aria-live="polite"
        elementID={t('buttons.addTeamMember')}
        menuItems={[
          {
            label: t('buttons.addNewTeamMember'),
            onClick: () => handleNavigation('/users/bulkuserupload'),
          },
          {
            label: t('buttons.addGroupOfTeamMember'),
            onClick: () => handleNavigation('/users/bulkuserupload'),
          },
        ]}
      />

      {/* code Ends for addUser button */}
    </>
  );
};

export default BulkUserLandingPage;
